module.exports = __webpack_public_path__ + "img/authorization.585e30cc.png";